import { sortByUpdatedAt } from '@witmetrics/utils/arrays';
import { useAllProjects, useDispatch } from '@witmetrics/data-store';
import { searchProjects } from '@/utils/options';
import { useAppState } from '@/providers/AppStateProvider';
import SearchableDropdown, {
  type SearchableDropdownOption,
  type SearchableDropdownProps,
} from '@/components/inputs/SearchableDropdown';

export type ProjectFieldProps = {
  disabled?: boolean;
  className?: string;
  value?: SearchableDropdownOption<number> | null;
  onSelect: (project: SearchableDropdownOption<number> | null) => void;
};

export default function ProjectField({
  disabled,
  className,
  value,
  onSelect,
}: ProjectFieldProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const projects = useAllProjects();

  const handleSearch: SearchableDropdownProps<number>['onSearch'] = async (
    search: string
  ) => {
    try {
      const { projects } = await searchProjects(search);
      dispatch.addProjects(projects);
      return projects.map((p) => ({
        value: p.id,
        label: p.name,
        description: p.description,
      }));
    } catch (err) {
      onApiError(err, 'Error finding cases');
      return [];
    }
  };

  const getInitialOptions = () => {
    if (value) return [value];
    if (projects.length > 0) {
      return sortByUpdatedAt(projects)
        .slice(0, 10)
        .map((p) => ({ label: p.name, value: p.id }));
    }
    return [];
  };

  return (
    <SearchableDropdown<number>
      disabled={disabled}
      className={className}
      label="Select a Case (optional)"
      value={value}
      initialOptions={getInitialOptions()}
      onSearch={handleSearch}
      onSelect={onSelect}
    />
  );
}
